

var article = `
## Windows Update - Error 80072EFE

Las actualizaciones en **Windows 7** no funcionan por el *Error 80072EFE*:

1. Abro este enlace: https://github.com/aakkam22/windowsUpdateLoopFix/releases .

2. Descargo **UpdateFixed.exe** y **Source Code** (zip).
  
3. Cierro *todos* los programas en ejecución.
  
4. Ejecuto **UpdateFixed.exe**.
  
Se abrirá la *consola* (**CMD**) y a continucación:

* Presionar el número **[1]** para acceder a la *corrección rápida*.

* Después presionar la letra **[A]** para *concederle acceso a internet* al programa.
  
Después solamente **esperar** que se descarguen las actualizaciones necesarias para que funcione **Windows Update**.

* Una vez que terminen de descargarse las actualizaciones deben *cierrarse todos los programas* y *desconectarse de internet* para no tener problemas con la instalación de las actuazliaciones que descargó.

* Luego la PC se reiniciará varias veces, hay que *volver a desactivar internet* después del reinicio.

* Y concederle *acceso de administrador* cada vez que se vuelva a prender.

Después de eso ya funcionará **Windows Update** en **Windows 7**.

**FUENTE:** https://github.com/aakkam22/windowsUpdateLoopFix.
      
`;

export default article;